<adf-comments 
    [readOnly]="readOnly"
    [id]="nodeId"
>
</adf-comments>